import { gql } from "@apollo/client";

const updatePartner = gql`
  mutation ($Partner: PartnerInput!, $Id: ID!, $isEditAllowed: Boolean) {
    updatePartner(input: $Partner, id: $Id, isEditAllowed: $isEditAllowed) {
      id
      name
      active
      description
      image
      programId
      type
    }
  }
`;

export default updatePartner;
